import axios from "axios";

export function getAdLoginUrl(params) {
  return axios({
    url: "/api/adlog/getadloginurl",
    method: "get",
    params: params,
  });
}
export function adLogin(params) {
  return axios({
    url: "/api/user/adlogin",
    method: "get",
    params: params,
  });
}
export function isaduser() {
  return axios({
    url: "/api/adlog/isaduser",
    method: "get",
  });
}